<template>
  <a href="javascript:;" @click.prevent="openQuickBuy" class="bcm-link bcm-link-none w-100">
    <div class="product-item">
      <div class="product-item-tile">
        <div class="wrapp-media">
          <img-product
            :imgPath="product.small_image.url"
            :alt="product.small_image.label"
            size="MD"
          />
        </div>
        <div class="wrapp-info">
          <div class="product-name">
            <h2 class="title">{{product.name}}</h2>
          </div>
          <div class="product-sku">
            <span class="text">{{product.sku}}</span>
          </div>
          <div class="product-price" v-show="productPrice">
            <span class="text">{{productPrice}}</span>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { price } from '@/filters'
import { localizedByName } from '@/filters/routers'
import ImgProduct from 'theme/components/Product/Image'

export default {
  name: 'ProductTile',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    productLink () {
      if (this.product) {
        let path = '/'
        if (this.$store.state.category.current && this.$store.state.category.current.url_path) {
          path += this.$store.state.category.current.url_path + '/'
        }
        return localizedByName('factoryPage', this.$store, this.$router) + path + this.product.url_key + this.product.url_suffix
      }
      return ''
    },
    productPrice () {
      if (this.product) {
        return price(this.product.price.regularPrice.amount.value, this.$store)
      } else {
        return 0
      }
    }
  },
  methods: {
    openQuickBuy ($event) {
      // const _this = this
      this.$store.commit('quickBuy/setToggle', true)
      this.$store.commit('quickBuy/setCurrentProductUrlKey', this.productLink)
    }
  },
  components: {
    ImgProduct
  }
}
</script>
